import { render, staticRenderFns } from "./PitchShiftEdit.vue?vue&type=template&id=d2b5fec6&scoped=true&"
import script from "./PitchShiftEdit.vue?vue&type=script&lang=js&"
export * from "./PitchShiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b5fec6",
  null
  
)

export default component.exports